var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 8.18184V12.0546H15.3818C15.1455 13.3001 14.4363 14.3546 13.3727 15.0637L16.6182 17.5819C18.5091 15.8365 19.6 13.2729 19.6 10.2274C19.6 9.51832 19.5364 8.83644 19.4182 8.18195L10 8.18184Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.39569 11.9034L3.66372 12.4637L1.07275 14.4819C2.71821 17.7455 6.09071 20.0001 9.99979 20.0001C12.6997 20.0001 14.9634 19.1092 16.618 17.5819L13.3725 15.0637C12.4816 15.6637 11.3452 16.0274 9.99979 16.0274C7.39979 16.0274 5.19075 14.2729 4.39978 11.9092L4.39569 11.9034Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.07276 5.51822C0.390977 6.86362 0.000106812 8.38183 0.000106812 10C0.000106812 11.6182 0.390977 13.1364 1.07276 14.4818C1.07276 14.4908 4.40011 11.8999 4.40011 11.8999C4.20011 11.2999 4.08189 10.6636 4.08189 9.99989C4.08189 9.33617 4.20011 8.69984 4.40011 8.09984L1.07276 5.51822Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3.98184C11.4728 3.98184 12.7818 4.49092 13.8273 5.47276L16.6909 2.60914C14.9545 0.990977 12.7 0 10 0C6.09091 0 2.71821 2.24546 1.07275 5.51822L4.4 8.10005C5.19087 5.73638 7.4 3.98184 10 3.98184Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.6,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/Google_logo.2cd1aea9fee9e1a3242b3d9e417d42a8.svg";
export { ForwardRef as ReactComponent };